import { Homeless, MemberSearchResult } from 'types';

import { formatDate } from 'util/index';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    detailsBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        backgroundColor: '#F2F2FD',
        border: '1px solid #E3E3FA',
        borderRadius: '8px',
        marginTop: '16px',
        padding: '24px'
    },
    detailField: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },
    detailLabel: {
        color: '#5A6A81',
        fontWeight: 300,
        fontSize: '16px'
    },
    detailValue: {
        color: '#1F2152',
        fontWeight: 700,
        fontSize: '18px'
    }
}));

type MemberDetailsProps = {
    member?: Homeless | MemberSearchResult | null;
    details?: ({
        label: string;
        value: string;
    } | null)[];
};
const getMembershipStatus = (profile_stage: string | undefined) => {
    switch (profile_stage) {
        case 'EXITED':
            return 'CLOSED';
        case 'LIVE':
            return 'ACTIVE';
        case 'NEEDS_REVIEW':
            return 'ACTIVE';
        case 'PENDING':
            return 'PENDING';
        case 'UNSUCCESSFUL_PENDING':
            return 'CLOSED';
        default:
            return '-';
    }
};

const MemberDetails: React.FC<MemberDetailsProps> = ({ details, member }) => {
    const classes = useStyles();

    const renderDetails = () => {
        //if no details and no member, return null
        if (!details && !member) {
            return null;
        }

        //if no details and member, return member details
        if (!details && member) {
            const details = []
            if (member.pii_first_name && member.pii_last_name) {
                details.push({ label: 'Full Name', value: `${member.pii_first_name} ${member.pii_last_name}` });
            }
            if (member.date_of_birth) {
                details.push({ label: 'Date of Birth', value: formatDate(member.date_of_birth) });
            }
            if (member.pii_member_id) {
                details.push({ label: 'Insurance ID', value: member.pii_member_id });
            }
            if (member.profile_stage) {
                details.push({ label: 'Current Membership Status', value: getMembershipStatus(member.profile_stage) });
            }
            return details;
        }

        //if details, return details
        return details;
    };

    return (
        <div className={classes.detailsBody}>
            {renderDetails()?.map((detail, index) =>
                detail ? (
                    <div className={classes.detailField} key={index}>
                        <span className={classes.detailLabel}>
                            {detail.label}
                        </span>
                        <span className={classes.detailValue}>
                            {detail.value}
                        </span>
                    </div>
                ) : null
            )}
        </div>
    );
};

export default MemberDetails;
